import { useSelectedValueAttributeByKey } from '@k3/core';

export const useShopName = () => {
  return (
    useSelectedValueAttributeByKey('model', 'shopName')?.value?.toString() ?? ''
  );
};

export const useIsEcktisch = () => {
  const shopName = useShopName();
  return shopName.toLowerCase().includes('eck');
};
